import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { menus } from '../../core/static/menu';
import { GetTitleDirective } from '../../modules/directive/get-title/get-title.directive';
import { SettingsService } from '@delon/theme';
import { CommonService } from '../../modules/service/common/common.service';
import { SystemService } from '../../modules/service/system/system.service';
import { userInfo } from 'os';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.less'],
})
export class LayoutComponent implements OnInit {
  smallPage: boolean = true; // 主体页面宽度  true  1200px  false 全屏宽度
  confirm_content: any = '确认退出去登录吗?'; // 弹框内容
  confirm_title: any = '提示'; // 弹框标题
  pop_up = false; // 弹框开关变量
  menus = menus;
  title: string;
  show_menu = true;
  menu_data: string;
  show_border = true;
  isHome: boolean = false;
  isSetting: boolean = false;
  cache: any;
  pageUrl: string = '';
  menuRole: object = {};
  showMenuData: Array<object> = []; // 可以展示的菜单
  updateInfo: boolean = false;
  updateLog: object = {};

  goBack(): void {
    if (this.isSetting) {
      this.toHome();
    } else if (!this.show_menu) {
      history.go(-1);
    } else {
      this.router.navigate(['/' + this.pageUrl]).then();
    }
  }

  setTitle(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data),
      )
      .subscribe((event) => {
        const urlInfo = this.router.url.split('/');
        if (event.all_width != undefined && event.all_width) {
          this.smallPage = false;
        } else {
          this.smallPage = true;
        }
        let nowModuleMenuRole = this.menuRole[urlInfo[1]];
        let nowModuleMenu = this.menus[urlInfo[1]];
        if (urlInfo[1] == 'setting') {
          nowModuleMenu = this.menus[urlInfo[2]];
          nowModuleMenuRole = this.menuRole[urlInfo[2]];
        }
        const showMenuData = [];
        if (nowModuleMenu != undefined) {
          nowModuleMenu.map((item) => {
            if (nowModuleMenuRole.indexOf(item['routing']) > -1) {
              showMenuData.push(item);
            }
          });
          this.showMenuData = [...showMenuData];
        } else {
          this.showMenuData = [];
        }
        this.pageUrl = urlInfo[1] == 'setting' ? 'setting' : 'home';
        if (event.menu_data == 'home') {
          this.isHome = true;
        } else {
          this.isHome = false;
        }
        if (event.menu_data == 'setting') {
          this.isSetting = true;
        } else {
          this.isSetting = false;
        }
        this.menu_data = event.menu_data;
        if (event.menu === false) {
          this.show_menu = false;
        } else {
          this.show_menu = true;
        }
        if (event.show_border === false) {
          this.show_border = false;
        } else {
          this.show_border = true;
        }
        this.titleService.setTitle(event.breadcrumb);
        this.title = this.titleService.getTitle();
      });
  }

  constructor(
    private getTitleDirective: GetTitleDirective,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    public settingsService: SettingsService, // private nzMessageService: NzMessageService,
    public common: CommonService,
    private system: SystemService,
  ) {
    this.setTitle();
    this.cache = { ...this.common.getCache('userInfo') };
    this.menuRole = { ...this.common.getCache('menuRole') };
    /**
     * 接收非子级模块传送的数据
     */
    this.common.childToParent$.subscribe((event: string) => {
      const params = JSON.parse(event);
      if (params['event'] == 'update') {
        if (!this.updateInfo && params['type']) {
          this.system.getNewUpdateLog().then((log) => {
            this.updateLog = { ...log };
            this.updateInfo = true;
          });
        }
      }
    });
  }

  cancel(): void {
    // this.nzMessageService.info('click cancel');
  }

  confirm(): void {
    this.pop_up = !this.pop_up;
    // this.router.navigate(['/passport/login']);
    // this.nzMessageService.info('click confirm');
  }

  suredit(): void {
    this.pop_up = !this.pop_up;
    this.common.removeCache('menuRole');
    this.router.navigate(['/passport/login']).then();
  }

  canceldit(): void {
    this.pop_up = !this.pop_up;
  }

  ngOnInit(): void {
  }

  jumpToSetting(): void {
    this.router.navigate(['/setting']).then();
  }

  toHome(): void {
    this.router.navigate(['/home']).then();
  }

  clickMenu(menu: any): void {
    const routing = menu.split('/').pop();
    const _pageData = this.common.getCache('pageData');
    if (_pageData != null && _pageData['pageName'] == routing) {
    } else {
      this.common.removeCache('pageData');
    }

    // 专用移除方案模块的页面选择岗位的缓存数据移除
    this.common.removeCache('dutiesData');
  }

  /**
   * 接收更新通知
   */
  updateReceive(): void {
    this.updateInfo = false;
    this.system.updateStatus().then((res) => {
      // this.updateInfo = false;
    });
  }

  /**
   * 跳转到帮助中心
   */
  jumpToHelp(): void {
    this.router.navigate(['/help']).then();
  }

  // 刷新
  reload(): void {
    location.reload();
  }
}
